var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0"},[_c('v-row',{staticClass:"d-flex flex-column align-center"},[_c('v-icon',{attrs:{"color":"red","large":""},on:{"click":function($event){return _vm.likePost()}}},[_vm._v("mdi-heart")]),_vm._v(" "),_c('span',{staticClass:"body-2"},[_vm._v(_vm._s(_vm.likesCount)+" ถูกใจ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }